import { createSearchParams } from 'react-router-dom';

import { ListItemIconProps } from '../../components/ListItemIcon/ListItemIcon';
import { PermissionFunction } from '../auth/auth.types';

export const appRoutePaths = {
  Account: 'account',
  AccountUser: 'account-user',
  AiCall: 'ai-call',
  CallCenter: 'call-center',
  CallLog: 'call-log',
  CallPop: 'call-pop',
  Company: 'company',
  CompanyWindow: 'company-window',
  MyCallCenter: 'my-call-center',
  Profile: 'profile',
  Schedule: 'schedule',
  SystemAdministration: 'administration',
  User: 'user',
  Forbidden: 'forbidden'
} as const;

export type AppRoutePath = (typeof appRoutePaths)[keyof typeof appRoutePaths];

export interface NavItem {
  icon: ListItemIconProps['children'];
  title: string;
  routePath: AppRoutePath;
  routeAllowed?: PermissionFunction;
}

export const appRoutePrefix = 'app' as const;

export const getFullAppRoutePath = (appRoutePath: AppRoutePath) => `/${appRoutePrefix}/${appRoutePath}`;

export type GoBackState = {
  url: string;
};

export function hasGoBack(state?: object): state is { goBack: GoBackState } {
  return !!state && 'goBack' in state && !!state.goBack && typeof state.goBack === 'object' && 'url' in state.goBack;
}

/**
 * Helper function for generating a 'GoBackState' using the contents of a URLSearchParams iterable
 *
 * @param appRoutePath
 * @param searchParams
 * @returns {GoBackState}
 */
export const getGoBackState = (appRoutePath: AppRoutePath, searchParams: URLSearchParams) => ({
  url: `${getFullAppRoutePath(appRoutePath)}?${createSearchParams(Array.from(searchParams.entries())).toString()}`
});
